import React from "react";
import { connect } from "react-redux";
import {nullifyPaymentAddingPage} from "../../services/patient/action"
import Header from "../../components/header";
import Footer from "../../components/footer";
import ChangePassword from './changePassword';
import FacilityEmr from '../facility/emrOrVpn/emrOrVpn';
import PractitionerVUD from '../facility/Practitioner/PractitionersList';
import EmployeSection from '../admin/employeSection';
import AppCostUpdate from '../admin/costUpdate';
import BestPerformance from '../admin/bestPerformance';
import $ from 'jquery';
import { footer } from "../../components/footerSize";
import FacilityList from "../employee/facilityList";
import NewFacilityList from '../employee/newFacilityRequest';
import AllReports from "../admin/reports/allReports";
import PatientPayment from "../patient/payment/payment";
import RecordReqList from '../employee/recordReqInfoList';
import SavedCards from '../patient/payment//savedCards';
import HedisFlatUpdate from '../admin/hedisFlatUpdate';
import Approval from '../facility/approval';
import DisableAccount from '../patient/disableAccount';

class Settings extends React.Component {
  constructor(props) {

    super(props)
    this.state = {
      userType: "",
      facility: "",
      patient: "",
      admin: "",
      employee: "",
 
      index:0
    };
  }
  componentDidMount() {
    // onDocumentReady function bind
    $(document).ready(function () {
      footer("#content");
    });

    // onResize bind of the function
    $(window).resize(function () {
      footer("#content");
    });
  
  

      if (this.props.profileDetails) {
      let username = this.props.profileDetails.commonUser.email;
      let access_token = this.props.loginDetails;
      let userType = this.props.profileDetails.commonUser.userType

      this.setState({
        access_token,
        username,
        userType
      }, () => {
        let { userType } = this.state
        if(this.props.paymentMethodNotAddedStatus){
          this.setState({
           index : 9
          },()=>{
           this.props.nullifyPaymentAddingPage();
          })
       } else if(this.props.location.state){
         if(this.props.location.state.page === "EmployeePage"){
         this.setState({
           index : 2
         })
        }

       }else{
        switch (userType) {
          case "patient" :
            this.setState({
             index : 8
            })
            break;
            case "other" :
            this.setState({
             index : 8
            })
            break;
          case "facility":
            this.setState({
              index : 0
            })
            break;
          case "employee":
            this.setState({
            index : 8
            })
            break;
          case "admin":
            this.setState({
              index : 11
            })
            break;
        }
      }
      })
    
    }
    
  }


  settingsNav = (e) => {
    e.preventDefault();

    let selectedItem = e.target.id;
    this.setState({
      index : selectedItem
    })
  
  }

  componentWillReceiveProps = nextProps =>{

    if(nextProps.disbaleAccountstatus){
      this.props.history.push("/login")
  }
}

changePage = () =>{
 this.setState({
   index: 9
})
}

pageChange = () =>{
this.setState({
   index: 10
})
}

  render() {

    const { index, userType } = this.state;
 
    return (
      <React.Fragment>
        <Header status={"afterLogin"} routes={[{ "name": "Settings", "route": "/Settings", }]} />

        <div className="content">

          <div className="contentSection" id="content">
            <div className="container-fluid">

              <div className="bodyContent">
                <div className=" set-page row">
                  <div className="set-but">
                    <div className="col-lg-3 col-md-3">
                      <ul  class="set-ul" type="none">
                        {userType == "facility" &&
                          <>
                            <li onClick={this.settingsNav} id={0} className={index == 0 ? "active" : ""}>
                               Practitioners 
                            </li>

                            <li onClick={this.settingsNav} id={1} className={index == 1  ? "active" : ""}>
                               EMR / VPN Setup 
                            </li>

                            
                            <li onClick={this.settingsNav} id={13} className={index == 13  ? "active" : ""}>
                               Prior Approval Settings 
                            </li>

                          </>}
                        {userType == "admin" &&
                          <>
                           <li onClick={this.settingsNav} id={11} className={index ==11 ? "active" : ""} >
                                 Requested Records
                            </li>
                            <li onClick={this.settingsNav} id={2} className={index == 2 ? "active" : ""} >
                                 Employee
                             </li>
                            <li onClick={this.settingsNav} id={3} className={ index == 3 ? "active" : ""}>
                               Registered Practice
                            </li>
                            <li onClick={this.settingsNav} id={4} className={index ==4 ? "active" : ""} >
                               Requested Practice
                            </li>

                            <li onClick={this.settingsNav} id={5} className={index ==5 ? "active" : ""} >
                                 Approximate Cost 
                            </li>
                            <li onClick={this.settingsNav} id={6} className={index ==6 ? "active" : ""} >
                                 Best Performance
                            </li>
                            <li onClick={this.settingsNav} id={7} className={index ==7 ? "active" : ""} >
                                 Reports
                           
                            </li>
                            <li onClick={this.settingsNav} id={12}  className={index == 12 ? "active" : ""} >
                           
                                 HEDIS Flat
                            </li>

                          </>}
                        <li onClick={this.settingsNav} id={8} className={index == 8 ? "active" : ""} >
                      
                            Change Password 
                        </li>
                        {userType == "patient"  &&
                        <>
                           <li onClick={this.settingsNav} id={14}  className={index == 14 ? "active" : ""} >
                             
                                Disable Account
                            </li>
                              <li onClick={this.settingsNav} id={9}  className={index == 9 ? "active" : ""} >
                             
                                 Add Payment
                            </li>
                            <li onClick={this.settingsNav} id={10}  className={index == 10 ? "active" : ""} >
                              
                                 Saved Cards
                            </li>

                            </>

                        }

                  {userType == "other"  &&
                        <>
                          <li onClick={this.settingsNav} id={14}  className={index == 14 ? "active" : ""} >
                              
                                Disable Account
                            </li>
                              <li onClick={this.settingsNav} id={9}  className={index == 9 ? "active" : ""} >
                               
                                 Add Payment
                            </li>
                            <li onClick={this.settingsNav} id={10}  className={index == 10 ? "active" : ""} >
                              
                                 Saved Cards
                            </li>
                            </>
                        }


                      </ul>
                    </div></div>


                  <div className="col-lg-9 col-md-9">
                  
                  {index == 11 &&
                      <RecordReqList role="admin" tab="fullList" />
                    }
                    {index == 3 &&
                      <FacilityList />
                    }
                    {index == 4 &&
                      <NewFacilityList />
                    }

                    {/* Tab for Practitioner View Edit Delete section in Facility settings*/}
                    {index == 0 &&
                      <PractitionerVUD />
                    }


                    {/* Tab For Change Password common for all*/}
                    {index == 8 &&
                      <ChangePassword />
                    }

                    {/* Tab For EMR in Facility settings*/}
                    {index == 1 &&
                      <FacilityEmr />
                    }


                    {/* Tab for Employe section in Admin settings */}
                    {index ==2  &&
                      <EmployeSection />
                    }
                    {/* Tab for Cost Update in Admin settings */}
                    {index == 5 &&
                      <AppCostUpdate />
                    }

                    {/* Tab for best performance in Admin settings */}
                    {index == 6 &&
                      <BestPerformance />
                    }
                    {index == 7 &&
                      <AllReports />
                    }
                      {index == 9 &&
                    
                      <PatientPayment   pageChange={this.pageChange}   />
                    }
                      {index == 10 &&
                    
                      <SavedCards  changePage={this.changePage} page="settings" />
                    }

                      {index == 12 &&
                                          
                        <HedisFlatUpdate  />
                      }
                       {index == 13 &&
                                          
                         <Approval  />
                                        }

                         {index == 14 && 
                            <DisableAccount />
                            }               
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
        {/* <!-- Edit data --> */}


      </React.Fragment>
    )
  }
}
const mapStateToProps = state => ({
  loginDetails: state.commonReducer.loginDetails,
  profileDetails: state.commonReducer.profileDetails,
  isAutoPayStatus : state.patientReducer.isAutoPayStatus,
  disbaleAccountstatus : state.patientReducer.disbaleAccountstatus,
  changePasswordStatus: state.commonReducer.changePasswordStatus,
  message: state.commonReducer.message,
  paymentMethodNotAddedStatus: state.patientReducer.paymentMethodNotAddedStatus


});

const mapDispatchToProps = dispatch => ({
  nullifyPaymentAddingPage: () => dispatch(nullifyPaymentAddingPage())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Settings);



